import { cn } from '@/lib/cn';

type SymboleProps = {
  /** Côté du carré 120 × 120 de la maquette, en px. Omis : le CSS fixe la taille. */
  size?: number;
  /**
   * Couleur de la calotte et du nœud. Par défaut le ciel ; `currentColor`
   * donne la version monochrome, obligatoire sous 24 px (charte § 04).
   */
  accent?: string;
  /** Tracé animé au chargement, puis rebond du i (en-tête, accueil). */
  animated?: boolean;
  /** Variante du grand symbole de l'accueil : le point s'élève au lieu de pulser. */
  big?: boolean;
  className?: string;
};

/**
 * Le symbole « Ai » (charte v2, § 02) : le sommet, la calotte, le nœud. Le
 * trait suit `currentColor` : encre sur clair, blanc sur encre.
 */
export function Symbole({
  size,
  accent = 'var(--color-ciel)',
  animated = false,
  big = false,
  className,
}: SymboleProps) {
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={cn('block shrink-0', animated && 'sym-anim', big && 'sym-big', className)}
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="a-a"
        d="M12 106 L50 22 L88 106"
        fill="none"
        stroke="currentColor"
        strokeWidth="13"
        strokeLinejoin="miter"
      />
      <polygon className="a-cap" points="50,22 36,53 45,48 50,56 55,48 64,53" fill={accent} />
      <g className="a-ig">
        <path className="a-i" d="M106 52 V106" stroke="currentColor" strokeWidth="13" />
        <circle className="a-dot" cx="106" cy="30" r="8" fill={accent} />
      </g>
    </svg>
  );
}
